@use '@dixa/lib-shared-tokens/scss' as *;

.root {
  padding: var(--dixa-size-spacer-250);
  background:
    linear-gradient(
      91.87deg,
      var(--dixa-color-purple-100) 1.58%,
      var(--dixa-color-neutral-000) 98.42%
    ),
    var(--dixa-color-purple-100);
  border-radius: var(--dixa-size-border-radius-100);
  @include border-100();
  border-color: var(--dixa-color-purple-600);
}
